import { User } from 'src/app/models/user';
import { IRepository } from 'src/app/repositories/interface.repository';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { CoreResponseMessage } from 'src/app/contracts/responseMessage/coreResponseMessage';
import { BaseRepository, OrderBy } from 'src/app/repositories/base.repository';
import { SessionService } from 'src/app/common/services/session.service';
import { FunctionsService } from 'src/app/common/services/functions.service';
import { ClientConfigService } from 'src/app/common/services/client-config.service';
import { Injectable } from "@angular/core";

export enum SortBy {
    Email,
    Role
}

@Injectable()
export class UserRepository extends BaseRepository implements IRepository { 
    private _sessionLoggedinUser: string = 'loggedinUser';

    constructor(public http: HttpClient, public functionsService: FunctionsService, public clientConfig: ClientConfigService, private _sessionService:SessionService) {
        super(http, functionsService, clientConfig, 'User');                
    }

    async getAsync(headers: HttpHeaders, ids: number[]): Promise<CoreResponseMessage> {
        let users: User[] = [];        
        return new CoreResponseMessage();
    }

    async addAsync(headers: HttpHeaders, addUsers: User[]): Promise<CoreResponseMessage> {
        let responseMsg: CoreResponseMessage;

        await this.http.post<CoreResponseMessage>(this.baseApiUrl + 'Add', JSON.stringify(addUsers), { headers }).toPromise().then(resp => {
            responseMsg = resp;
        }).catch(err => {
            responseMsg = err.error;
        });

        return responseMsg;
    }

    async updateAsync(headers: HttpHeaders, updateUser: User): Promise<CoreResponseMessage> {
        let responseMsg: CoreResponseMessage;

        await this.http.post<CoreResponseMessage>(this.baseApiUrl + 'Update', JSON.stringify(updateUser), { headers }).toPromise().then(resp => {
            responseMsg = resp;
        }).catch(err => {
            responseMsg = err.error;
        });
        
        return responseMsg;
    }

    async updateSelfAsync(headers: HttpHeaders, updateUser: User): Promise<CoreResponseMessage> {
        let responseMsg: CoreResponseMessage;

        await this.http.post<CoreResponseMessage>(this.baseApiUrl + 'UpdateUserSelf', JSON.stringify(updateUser), { headers }).toPromise().then(resp => {
            responseMsg = resp;
        }).catch(err => {
            responseMsg = err.error;
        });

        return responseMsg;
    }

    async signout(headers: HttpHeaders): Promise<CoreResponseMessage> {
        let responseMsg: CoreResponseMessage;

        await this.http.post<CoreResponseMessage>(this.baseApiUrl + 'Signout', null, { headers }).toPromise().then(resp => {
            responseMsg = resp;
        }).catch(err => {
            responseMsg = err.error;
        });
        
        return responseMsg;
    }

    async removeAsync(headers: HttpHeaders, ids: number[]): Promise<CoreResponseMessage> {
        let responseMsg: CoreResponseMessage;
        await this.http.post<CoreResponseMessage>(this.baseApiUrl + 'Delete', JSON.stringify(ids), { headers }).toPromise().then(resp => {
            responseMsg = resp;
        }).catch(err => {
            responseMsg = err.error;
        })

        return responseMsg;
    }
    
    getLoggedinUser(): User {
        let user: User = this._sessionService.get(this._sessionLoggedinUser, null); 
        
        if (!user)
            user = this.setDefaultLoggedinUser();

        return user;
    }

    setLoggedinUser(user: User) {
        this._sessionService.set(this._sessionLoggedinUser, user);    
    }

    setDefaultLoggedinUser(): User {    
        let defaultUser: User = { Id: 0, Email: '', Password: '', Active: false, Role: '', IsLoggedIn: false, LastActivityTime: null, CreatedDate: null, ApplicationId: 0, 
                                  ApplicationName: '', ApplicationKey: '', IsAdmin: false };
        this._sessionService.set(this._sessionLoggedinUser, defaultUser);
        return this._sessionService.get(this._sessionLoggedinUser, null);
    }

    async loginAsync(email: string, password: string, ipAddress: string): Promise<CoreResponseMessage> {                               
        let responseMsg: CoreResponseMessage;
        const headers = new HttpHeaders().set('IpAddress', ipAddress)
                                         .set('Email', email)
                                         .set('Password', password);        
        await this.http.get<CoreResponseMessage>(this.baseApiUrl + 'Login', { headers }).toPromise().then(resp => {
            responseMsg = resp;
        }).catch(err => {
            responseMsg = err.error
        });
                
        return responseMsg;
    }

    async signupAsync(email: string, password: string): Promise<CoreResponseMessage> {
        let responseMsg: CoreResponseMessage;
        let user = { Email: email, Password: password };
        const headers = new HttpHeaders().set('Content-Type', 'application/json');

        await this.http.post<CoreResponseMessage>(this.baseApiUrl + 'Signup', JSON.stringify(user), { headers }).toPromise().then(resp => {
            responseMsg = resp;
        }).catch(err => {
            responseMsg = err.error;
        })

        return responseMsg;
    }
    
    async getAllAsync(headers: HttpHeaders, pageIndex: number, pageSize: number, sortBy: SortBy, orderBy: OrderBy): Promise<CoreResponseMessage> {
        let responseMsg: CoreResponseMessage;
        const params = new HttpParams().set('pageIndex', pageIndex.toString())
                                       .set('pageSize', pageSize.toString())
                                       .set('sortBy', sortBy.toString())
                                       .set('orderBy', orderBy.toString());        
        await this.http.get<CoreResponseMessage>(this.baseApiUrl + 'GetAllUsers', { headers, params }).toPromise().then(resp => {
            responseMsg = resp;
        }).catch(err => {
            responseMsg = err.error;
        });

        return responseMsg;
    }

    async forgotPasswordAsync(headers: HttpHeaders): Promise<CoreResponseMessage> {
        let responseMsg: CoreResponseMessage;

        await this.http.get<CoreResponseMessage>(this.baseApiUrl + 'ForgotPassword', { headers }).toPromise().then(resp => {
            responseMsg = resp;
        }).catch(err => {
            responseMsg = err.error;
        });

        return responseMsg;
    }
}